import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import EditIcon from '@mui/icons-material/Edit';
import AgregarClienteEspecialModal from "./AgregarClienteEspecialModal";
import EditarClienteEspecialModal from "./EditarClienteEspecialModal";
import { FiltroClientesEspeciales } from "./FiltroClientesEspeciales";
import { GetKey } from "../../CreditoyCobranza/ReporteCobranza/Actions/GetContainer";
import { useBox } from "../../CreditoyCobranza/ReporteCobranza/Helper/useBox";
import SubirListadoModal from "./SubirListadoModal";
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';

export const ClientesEspecialesScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [clientes, setClientes] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [openModalDocumento, setOpenModalDocumento] = useState(false);
    const [selectedID, setSelectedID] = useState();
    const [boxstate, setBoxState] = useBox();
    const [tipo, setTipo] = useState();

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModalEditar = (id) => {
        setSelectedID(id);
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {
        setSelectedID(null)
        setOpenModalEditar(false);
    };

    const handleOpenModalDocumento = () => {
        setOpenModalDocumento(true);
    };

    const handleCloseModalDocumento = () => {
        setOpenModalDocumento(false);
    };

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `ClientesEspeciales/Listado?tipo=${tipo}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setClientes(result);
                return;
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                return;
            });
        setLoader({ ...loader, mostrar: false });
    }, [openModal, openModalEditar]);

    const onGeneraExcel = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ClientesEspeciales/ImprimirExcel?tipo=${tipo}`)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };

    const onExecute = (tipo) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            setTipo(tipo);
            request
                .get(
                    `ClientesEspeciales/listado?tipo=${tipo}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setClientes(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const handleDescargarListado = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ClientesEspeciales/Documento?tipo=${tipo}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                // console.log(result[0].documento)
                if (!result || result.length === 0 || !result[0].documento) {
                    Swal.fire(
                        "DESCARGAR LISTADO",
                        "No se ha subido un documento para este tipo de clientes.",
                        "warning"
                    );
                    return;
                }
                const linkSource = result[0].documento;
                const downloadLink = document.createElement("a");
                const fileName = `DOCUMENTO CLIENTES ESPECIALES`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("DESCARGAR EVIDENCIA", JSON.stringify(error), "error");
            });
    };

    // console.log(clientes)

    return (
        <PlantillaScreen
            titulo={`CLIENTES ESPECIALES`}
            className={"clientes-especiales-main-screen"}
            className_main={1}
        >
            <div className="clientes-especiales-actions">
                <div
                    className="clientes-especiales-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="clientes-especiales-actions-filtro">
                    <FiltroClientesEspeciales onExecute={onExecute} />
                </div>
                <div className="buttons">
                    <button className="excel"
                        onClick={() => onGeneraExcel()}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button className="clientes-especiales-header-agregar-objecion"
                        onClick={() => handleOpenModal()}
                    >
                        <AddCircleOutlineIcon /> Agregar
                    </button>
                </div>
            </div>
            <div className="clientes-especiales">
                <LoaderScreen loader={loader} />
                <div className="clientes-especiales-header">
                    <div className="clientes-especiales-header-title">
                        <FormatListNumberedIcon />     {tipo && tipo === "P"
                            ? "Listado de Clientes Especiales de Plataforma"
                            : tipo && tipo === "N"
                                ? "Listado de Clientes Especiales que no Pagan Interés"
                                : tipo && tipo === "F"
                                    ? "Listado de Clientes Especiales que no Firman Pagaré"
                                    : "Listado de Clientes Especiales"}
                    </div>
                    {(tipo === "N" || tipo === "F") && (
                        <div className="clientes-especiales-header-buttons">
                            <button className="button-subir-listado" onClick={handleOpenModalDocumento}> <UploadIcon />Subir Documento</button>
                            <button className="button-descargar-listado" onClick={handleDescargarListado}> <DownloadIcon />Descargar Documento</button>
                        </div>
                    )}
                </div>
                <div className="clientes-especiales-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Razón Social</th>
                                {/* <th>
                                    <div>Razón Social</div>
                                </th> */}

                                <th>
                                    <div>Comentarios</div>
                                </th>

                                <th>
                                    <div>Tipo de Cliente</div>
                                </th>

                                <th>
                                    <div>Estado</div>
                                </th>

                                <th>
                                    <div>Empleado</div>
                                </th>

                                <th>
                                    <div style={{ color: 'transparent' }}>.</div>
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((ctl) => (
                                <tr key={ctl.idcliente}>
                                    {/* <td className="id-celda">{ctl.idcliente}</td> */}
                                    <td className="razon-social-celda">{ctl.razon_social}</td>
                                    <td className="comentarios-celda">{ctl.comentarios}</td>
                                    <td className="tipo-celda">{ctl.tipo_cliente}</td>
                                    <td className="estatus-celda">{ctl.estatus}</td>
                                    <td className="empleado-celda">{ctl.empleado}</td>
                                    <td className="ta-editar">
                                        <div className="clientes-especiales-acciones-listado">
                                            <div
                                                className="boton-editar-clientes-especiales"
                                                onClick={() => handleOpenModalEditar(ctl.idcliente)}
                                            >
                                                <EditIcon /> Editar
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <AgregarClienteEspecialModal
                    open={openModal}
                    onClose={handleCloseModal}
                    tipo={tipo}
                //   folio={folio}
                />
                <EditarClienteEspecialModal
                    open={openModalEditar}
                    onClose={handleCloseModalEditar}
                    id={selectedID}
                />
                <SubirListadoModal
                    open={openModalDocumento}
                    onClose={handleCloseModalDocumento}
                    tipo={tipo}
                />
            </div>
        </PlantillaScreen>
    );
};
